//Color Swatches Start 
document.addEventListener("mouseover", function (e) {
  var swatch = e.target.closest(".color-swatch");
  if (!swatch) return;
  var card = swatch.closest(".card");
  if (!card) return;
  var img = card.querySelector(".card__media img");
  var newImage = swatch.getAttribute("data-variant-image");
  if (!img || !newImage) return;
  if (!img.dataset.originalSrc) {
    img.dataset.originalSrc = img.getAttribute("src");
    img.dataset.originalSrcset = img.getAttribute("srcset");
  }
  img.setAttribute("src", newImage);
  img.setAttribute("srcset", newImage);
});
document.addEventListener("mouseout", function (e) {
  var swatch = e.target.closest(".color-swatch");
  if (!swatch) return;
  var card = swatch.closest(".card");
  if (!card) return;
  var img = card.querySelector(".card__media img");
  if (!img || !img.dataset.originalSrc) return;
  img.setAttribute("src", img.dataset.originalSrc);
  img.setAttribute("srcset", img.dataset.originalSrcset);
});

document.addEventListener("click", function (e) {
  var swatch = e.target.closest(".color-swatch");
  if (!swatch) return;
  var url = swatch.getAttribute("data-variant-url");
  if (url) {
    window.location.href = url;
  }
});
//Color Swatches End
//Accordions JS 
(function () {
  function openAccordion(acc) {
    const content = acc.querySelector('.g-accordion__content');
    acc.classList.add('active');
    content.style.height = content.scrollHeight + 'px';
  }
  function closeAccordion(acc) {
    const content = acc.querySelector('.g-accordion__content');
    content.style.height = content.scrollHeight + 'px';
    requestAnimationFrame(() => {
      content.style.height = '0px';
    });
    acc.classList.remove('active');
  }
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-g-accordion-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const current = trigger.closest('.g-accordion');
    document.querySelectorAll('.g-accordion.active').forEach(acc => {
      if (acc !== current) {
        closeAccordion(acc);
      }
    });
    if (current.classList.contains('active')) {
      closeAccordion(current);
    } else {
      openAccordion(current);
    }
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target
      .querySelectorAll('.g-accordion.active .g-accordion__content')
      .forEach(content => {
        content.style.height = content.scrollHeight + 'px';
      });
  });

})();
document.addEventListener('DOMContentLoaded', function () {
  // Header Hight and Search Bar
  const header = document.querySelector('.shopify-section-header-sticky');
  const search_wrapper = document.querySelector('.search-modal.modal__content');
  const headerHeight = header ? header.offsetHeight : 0;
  if (search_wrapper) {
    search_wrapper.style.top = `${headerHeight}px`;
  }
});
(function () {
  if (typeof window.jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
    return;
  }

  $('.for_slider_init').each(function () {
    var $slider = $(this);
    var desktopItems = $slider.data('desktop-item') || 3;
    var mobileItems = $slider.data('mobile-item') || 2.1;
    $slider.slick({
      infinite: false,
      slidesToShow: desktopItems,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: desktopItems
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: mobileItems,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        }
      ]
    });

  });

})();
document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth <= 749) {
    const sections = document.querySelectorAll('.fetured_categories');
    if (sections.length > 0) {
      const wrapper = document.createElement('div');
      wrapper.className = 'featured-wrappers';
      sections[0].parentNode.insertBefore(wrapper, sections[0]);
      sections.forEach(section => {
        wrapper.appendChild(section);
      });
    }
  }
  // Wrapping Element 
  function wrapSections() {
    if (window.matchMedia("(min-width: 768px)").matches) {

      if (document.querySelector(".custom-wrapper-section")) return;

      const selectors = [
        ".features_multicolumns",
        ".denim_sections",
        ".outfit-section"
      ];

      const elements = selectors
        .map(selector => document.querySelector(selector))
        .filter(el => el !== null);

      if (elements.length) {
        const wrapper = document.createElement("div");
        wrapper.className = "custom-wrapper-section";

        const firstElement = elements[0];
        firstElement.parentNode.insertBefore(wrapper, firstElement);

        elements.forEach(el => {
          wrapper.appendChild(el);
        });
      }
    }
  }
  wrapSections();
  window.addEventListener("resize", wrapSections);
  //Wrapper Section End
  function wrapSpecificSectionsDesktop() {

  const existingWrapper = document.querySelector('.desktop-sections-wrapper');
  const sections = document.querySelectorAll(
    '.pricing-promise-section, .fetured_categories, .video_column'
  );

  if (window.innerWidth >= 750) {

    if (!existingWrapper && sections.length > 0) {

      const wrapper = document.createElement('div');
      wrapper.className = 'desktop-sections-wrapper';

      sections[0].parentNode.insertBefore(wrapper, sections[0]);

      sections.forEach(section => {
        wrapper.appendChild(section);
      });

    }

  } else {

    // Restore on mobile
    if (existingWrapper) {
      const parent = existingWrapper.parentNode;
      const items = existingWrapper.children;

      while (items.length > 0) {
        parent.insertBefore(items[0], existingWrapper);
      }

      existingWrapper.remove();
    }

  }
}

wrapSpecificSectionsDesktop();
window.addEventListener('resize', wrapSpecificSectionsDesktop);
});

document.addEventListener("DOMContentLoaded", function () {
    const section1 = document.querySelector(".features_multicolumns");
    const section2 = document.querySelector(".nightwear-promo-sections");
    const section3 = document.querySelector(".this-week-section");

    if (section1 && section2) {
      // Create wrapper
      const wrapper = document.createElement("div");
      wrapper.className = "mobile-combined-wrapper";

      // Insert wrapper before first section
      section1.parentNode.insertBefore(wrapper, section1);

      // Move both sections inside wrapper
       wrapper.appendChild(section2);
      wrapper.appendChild(section1);
       wrapper.appendChild(section3);
     
    }
});